import React from "react"
import request from "superagent"
import { Flex, Box } from "rebass"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"

import MaxWidth from "../MaxWidth"
import BwDisplayGroup from "../BwDisplayGroup"
import Gauge from "../Gauge"
import MessageBanner from "../MessageBanner"
import ThrottleSwitch from "../ThrottleSwitch"
import getQueryVariable from "../../util/AppUtils.js"

const API_SERVER = "https://calgary.ykwc.com"

class App extends React.Component {
  constructor(props) {
    super(props)
    this.handleToggleRequest = this.handleToggleRequest.bind(this)

    this.state = {
      isThrottle: false,
      nightGigs: false,
      inactive: false,
      host: "loading...",
      max: 0,
      emailSent: "00/0000",
      currentBonus: 0,
      month1: {
        cap: 0,
        label: "",
        month: 1,
        year: 1,
        total: 0,
        bandwidth: [],
      },
      month2: {
        cap: 0,
        label: "",
        month: 1,
        year: 1,
        total: 0,
        bandwidth: [],
      },
      month3: {
        cap: 0,
        label: "",
        month: 1,
        year: 1,
        total: 0,
        bandwidth: [],
      },
      throttled: false,
      requestsThrottle: false,
      requestsUnthrottle: false,
      overCap: false,
    }
  }

  handleToggleRequest() {
    let switched = this.state.throttled
    this.setState({ switched: !switched, requestLoading: true })
    if (switched) {
      this.destroyRequest.bind(this)()
    } else {
      this.createRequest.bind(this)()
    }
  }

  createRequest() {
    let key = getQueryVariable("key")
    request
      .post(`${API_SERVER}/v1/throttle_requests`)
      .set("Accept", "application/json")
      .set("Authorization", key)
      .end(
        function (error, response) {
          let switched
          if (error) {
            toast.error("Something went wrong.  Please try again later.")
            switched = false
          } else {
            toast.info(
              "Your connection will be throttled in the next 10 minutes",
            )
            switched = true
          }
          setTimeout(this.setState({ requestLoading: false }), 500)
          this.setState({
            switched: switched,
          })
        }.bind(this),
      )
  }

  destroyRequest() {
    if (
      !window.confirm(
        "Are you sure you want to unthrottle? You may accrue overages.",
      )
    ) {
      this.setState({ requestLoading: false })
      return
    }
    let key = getQueryVariable("key")
    request
      .del(`${API_SERVER}/v1/throttle_requests`)
      .set("Accept", "application/json")
      .set("Authorization", key)
      .end(
        function (error, response) {
          let switched
          if (error) {
            toast.error("Something went wrong.  Please try again later.")
            switched = true
          } else {
            toast.info(
              "Your connection will return to full speed in the next 10 minutes",
            )
            if (this.state.overCap) {
              toast.error(
                "You have already reached your cap. You will be charged for any additional unthrottled usaged.",
              )
            }
            switched = false
          }
          setTimeout(this.setState({ requestLoading: false }), 500)
          this.setState({
            switched: switched,
          })
        }.bind(this),
      )
  }

  getStateFromServer() {
    // for dev must append ?key=<key> to url
    let key = getQueryVariable("key")
    request
      .get(`${API_SERVER}/v1/bandwidth`)
      .set("Accept", "application/json")
      .set("Authorization", key)
      .end(
        function (error, response) {
          if (error) {
            toast.error("Failed to fetch data from server.")
            this.setState({
              host: "failed to fetch data...",
              isThrottle: false,
              throttled: false,
            })
          } else {
            let jsonData = JSON.parse(response.text)
            this.setState(jsonData)
          }
        }.bind(this),
      )
  }

  componentDidMount() {
    this.getStateFromServer()
  }

  pendingMessage() {
    if (this.state.requestsThrottle && !this.state.throttled) {
      return "(Throttle Pending...)"
    } else if (this.state.requestsUnthrottle && this.state.throttled) {
      return "(Unthrottle Pending...)"
    } else {
      return ""
    }
  }

  render() {
    const { month1, month2, month3 } = this.state
    const months = [month1, month2, month3]

    return (
      <Flex flexDirection="column" style={{ minHeight: "100vh" }}>
        <ToastContainer autoClose={10000} closeOnClick={false} />

        <MaxWidth flexDirection="column" mt={3} pt={3}>
          <MessageBanner
            active={this.state.inactive}
            message="Inactive Host"
            bg="#d9534f"
          />
          <MessageBanner
            active={this.state.currentBonus && this.state.currentBonus > 0}
            message={`Additional data: ${this.state.currentBonus}GB added to your cap this month`}
            bg="green"
          />

          <Flex flexDirection="column" alignItems="center" mb={4} pb={4}>
            <h1 className="button" style={{ pointerEvents: "none" }}>
              {this.state.host}
            </h1>
            {this.state.isThrottle && (
              <div>
                <ThrottleSwitch
                  throttled={this.state.throttled}
                  pendingMessage={this.pendingMessage()}
                  requestLoading={this.state.requestLoading}
                  handleToggleRequest={this.handleToggleRequest}
                />
              </div>
            )}
            <div className="two spacing" />
          </Flex>

          <Flex flexWrap="wrap" my={4}>
            {months.map((monthData, i) => (
              <Box width={[1, 1, 1 / 3, 1 / 3]}>
                <Gauge num={i} monthData={monthData} max={this.state.max} />
              </Box>
            ))}
          </Flex>

          <BwDisplayGroup
            isThrottle={this.state.isThrottle}
            month1={this.state.month1}
            month2={this.state.month2}
            month3={this.state.month3}
            nightGigs={this.state.nightGigs}
          />

          <Box px={4} py={3}>
            Warning Email Sent: {this.state.emailSent || "00/0000"}
          </Box>
        </MaxWidth>
      </Flex>
    )
  }
}

export default App
